module.exports = __webpack_public_path__ + "static/media/pn-pc-lime.dfa24755.svg";